import React, { useState, useCallback, useRef } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import MaterialTable, { MTableToolbar } from 'material-table';
import CircleIcon from '@material-ui/icons/Brightness1';
import { HandleDelete } from 'components/';

import {
  CardContent,
  Grid,
  Button,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  TextField,
} from '@material-ui/core';

import { useStyles } from './styles';

import { SubCategoryData } from 'services/dataService';
import { statusCategories } from 'constants/status';
import { localizationTable, options } from 'constants/table';
import { Search } from '@material-ui/icons';

export default () => {
  const [status, setStatus] = useState('true');
  const [name, setName] = useState('');
  const [category, setCategory] = useState('');
  const [modalStatus, setModalStatus] = useState(false);
  const [route, setRoute] = useState('');

  const history = useHistory();
  const { t } = useTranslation([
    'label',
    'toastify',
    'tables',
    'form',
    'button',
    'validation',
  ]);
  const { register, handleSubmit, control } = useForm();
  const tableRef = useRef();

  const classes = useStyles();

  const handleEdit = useCallback(
    ({ id }) => {
      history.push(`subcategories/${id}/edit`);
    },
    [history]
  );

  const onSubmit = (data) => {
    setName(data.name);
    setStatus(data.status);
    setCategory(data.category);

    tableRef.current.state.query.page = 0;
    tableRef.current.onQueryChange();
  };

  const handleModalOpen = useCallback(({ id }) => {
    setModalStatus(true);
    setRoute(`subcategories/${id}`);
  });

  return (
    <>
    <div className='notranslate'>
    <MaterialTable
        title={`${t('tables:subcategory.title')}`}
        tableRef={tableRef}
        columns={[
          {
            title: `${t('tables:subcategory.name_column')}`,
            field: `name`,
            sorting: false,
            render: (rowData) => rowData.name,
          },
          {
            title: `${t('tables:category.name_column')}`,
            field: `category.name`,
            sorting: false,
            render: (rowData) => rowData.category.name,
          },
          {
            title: `${t('tables:commons.status_column')}`,
            field: 'status',
            sorting: false,
            render: (rowData) => (
              <div style={{ display: 'flex' }}>
                <CircleIcon
                  style={statusCategories[rowData.status]?.style}
                  fontSize="small"
                />
                <span style={{ fontWeight: 'bold', fontSize: 14 }}>
                  {t(statusCategories[rowData.status]?.title)}
                </span>
              </div>
            ),
          },
        ]}
        data={async (query) => {
          try {
            const response = await SubCategoryData.getSubCategories({
              page: query.page + 1,
              limit: query.pageSize,
              status,
              name,
            });

            return {
              data: response.data.subCategories,
              page: response.data.currentPage - 1,
              totalCount: response.data.totalCount,
            };
          } catch (err) {
            if (err.response?.status === 403) {
              toast.error(t('toastify:commons.toast_error_403'));
            } else {
              toast.error(t('toastify:commons.toast_error_api'));
            }
            return { data: [] };
          }
        }}
        components={{
          search: true,
          title: true,
          Toolbar: (props) => (
            <div>
              <MTableToolbar {...props} />
              <form onSubmit={handleSubmit(onSubmit)}>
                <CardContent>
                  <Grid container spacing={3}>
                    <Grid item md={5} xs={12}>
                      <TextField
                        fullWidth
                        label={t('form:Subcategories.input_subcategory')}
                        name="name"
                        type="text"
                        variant="outlined"
                        defaultValue={name || ''}
                        inputRef={register}
                      />
                    </Grid>
                    <Grid item md={2} xs={12}>
                      {/* <TextField
                        fullWidth
                        label={t('form:Categories.input_category')}
                        name="category"
                        type="text"
                        variant="outlined"
                        defaultValue={category || ''}
                        inputRef={register}
                      /> */}
                    </Grid>

                    <Grid item md={2} xs={12}>
                      {/* <FormControl style={{ minWidth: 100 }}>
                        <InputLabel id="status">
                          {t('form:commons.input_status')}
                        </InputLabel>

                        <Controller
                          as={
                            <Select>
                              <MenuItem value="true">
                                {t(statusCategories['true']?.title)}
                              </MenuItem>
                              <MenuItem value="false">
                                {t(statusCategories['false']?.title)}
                              </MenuItem>
                            </Select>
                          }
                          name="status"
                          control={control}
                          defaultValue={status ? status : 'true'}
                          value={status ? status : 'true'}
                        />
                      </FormControl> */}
                    </Grid>
                    <Grid item md={3} xs={12} className={classes.actions}>
                      <Button
                        color="primary"
                        variant="contained"
                        size="large"
                        type="submit"
                      >
                        {t('button:commons.btn_advanced_filter')}
                        <Search />
                      </Button>
                    </Grid>
                  </Grid>
                </CardContent>
              </form>
            </div>
          ),
        }}
        actions={[
          {
            icon: 'edit',
            tooltip: `${t('tables:commons.actions.edit_action')}`,
            onClick: (event, rowData) => {
              handleEdit(rowData);
            },
            iconProps: { color: 'primary' },
          },
          {
            icon: 'delete',
            tooltip: `${t('tables:commons.actions.delete_action')}`,
            onClick: (event, rowData) => handleModalOpen(rowData),
            iconProps: { color: 'error' },
          },
        ]}
        localization={localizationTable(t)}
        options={options}
      />
    </div>
      <HandleDelete
        closeModal={setModalStatus}
        isOpen={modalStatus}
        route={route}
        tableRef={tableRef.current}
      />
    </>
  );
};
